import { render, staticRenderFns } from "./newScan.vue?vue&type=template&id=0f944060&"
import script from "./newScan.vue?vue&type=script&lang=js&"
export * from "./newScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports